import { gql } from "@apollo/client";

export default gql`
  query BookingQuotationReference($id: Int!) {
    bookingQuotation(id: $id) {
      id
      process {
        id
        referenceCode
      }
    }
  }
`;
